import React, { useState, useEffect } from "react";
import AccountList from "../accountList/AccountList";
import Select from "react-select";
import { connect } from "react-redux";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { Input, Checkbox, Icon, Popup } from "semantic-ui-react";
import "../../../../SettingsContainer/InstagramHashTag/InstagramHashTag.scss";

import "../PlatformConfig.scss";
import { fetchIgTokenList, storeIgSocialToken } from "../../../../../actions/tokensAction";
import SocialTokenScopeModal from "../../../Tokens/SocialTokenScopeModal";

function AdditionalDataInstagram(props) {
    const [openPermissionModal, setOpenPermissionModal] = useState(false);

    useEffect(() => {
        props.fetchIgTokenList();
    }, []);

    useEffect(() => {
        if (
            props.validAccounts &&
            props.validAccounts[0]?.account_exist &&
            props.validAccounts[0]?.details[0].name.toLowerCase() === props.accountName.toLowerCase()
        ) {
            let country;
            let entity;
            if (props.validAccounts[0].details[0].country_id)
                country = props.getCountryList().find((val) => val.value === props.validAccounts[0].details[0]?.country_id);
            if (props.validAccounts[0].details[0].entity_sub_type)
                entity = props.entityList.find((val) => val.value === props.validAccounts[0].details[0]?.entity_sub_type);

            props.setValidCountry(country);
            props.setValidEntity(entity);
        }
    }, [props.validAccounts]);

    useEffect(() => {
        props.setValidCountry(null);
    }, [props.location]);

    useEffect(() => {
        props.setValidEntity(null);
    }, [props.entityType]);

    return (
        <div className="additionalDataInstagram">
            <section className="parentSection">
                <div className="addAccountBlock">
                    <div className="authenticateSection">
                        <section className="leftSection">
                            <Popup
                                inverted
                                content="Instagram"
                                style={{ backgroundColor: "#1f2e3d" }}
                                trigger={
                                    <div>
                                        <img src={props.icon} className="platformIcon" alt="insta icon" />
                                    </div>
                                }
                            />

                            {props.igTokenList.length === 0 ? (
                                <div className="authenticateRefresh">
                                    <p className="common__btn" onClick={() => setOpenPermissionModal(true)}>
                                        Authenticate
                                    </p>
                                    <p onClick={props.fetchIgTokenList}>
                                        <Popup
                                            className="skiptranslate"
                                            trigger={<Icon name="refresh" size="large" />}
                                            content="Refresh"
                                            inverted
                                            position="bottom center"
                                            size="mini"
                                        />
                                    </p>
                                </div>
                            ) : (
                                <div className="validToken">
                                    <p>
                                        <Icon color="green" name="check" />
                                    </p>
                                    <p>Valid token found</p>
                                </div>
                            )}
                            <SocialTokenScopeModal
                                open={openPermissionModal}
                                onClose={() => setOpenPermissionModal(false)}
                                platform={{ name: "instagram" }}
                                storeIgSocialToken={props.storeIgSocialToken}
                                packageObj={props.packageObj}
                            />
                        </section>
                        <div onClick={props.closeComponent}>
                            <button className="common__btn ml-1 backButton">Back to Social Accounts</button>
                        </div>
                    </div>
                    {props.igTokenList.length === 0 && (
                        <div className="requestAuthenticateBlock">
                            <div className="warningMessage">
                                <p>
                                    <Icon name="warning sign" color="red" />
                                </p>
                                <p>Missing token</p>
                            </div>
                            <p>
                                You cannot configure accounts or pages for this platform as you have not authenticated yet. Please click on the
                                &quot;Authenticate&quot; button above. This will open a new window where you can authenticate. Once done you can come back to
                                this page and configure your accounts.
                            </p>
                        </div>
                    )}

                    <section className={`add_account-form  ${props.igTokenList.length === 0 && "disablePlatform"}`}>
                        <div className="field__row m-10">
                            <>
                                <div className="field__wrap">
                                    <label>Account Name*</label>
                                    <input
                                        type="text"
                                        className="add__input"
                                        placeholder="Enter Account name"
                                        value={props.accountName}
                                        onChange={(e) => props.handleUrlChange(e)}
                                    />
                                </div>

                                {props.isAccountValid && (
                                    <>
                                        <div className="field__wrap">
                                            <label>Location</label>
                                            <Select
                                                className="platform-list"
                                                value={props.validCountry || props.location}
                                                isSearchable
                                                placeholder="Select Location"
                                                options={props.getCountryList()}
                                                onChange={props.handleLocationChange}
                                                formatOptionLabel={props.formatOptionLabel}
                                                maxMenuHeight={140}
                                                styles={props.customStyle}
                                                isClearable
                                                components={{ IndicatorSeparator: () => null }}
                                            />
                                        </div>
                                        <div className="field__wrap">
                                            <label>Entity Type</label>
                                            <Select
                                                className="platform-list"
                                                value={props.validEntity || props.entityType}
                                                isSearchable
                                                placeholder="Select Entity Type"
                                                options={props.entityList}
                                                onChange={props.handleEntityTypeChange}
                                                maxMenuHeight={140}
                                                styles={props.customStyle}
                                                isClearable
                                                components={{ IndicatorSeparator: () => null }}
                                            />
                                        </div>
                                    </>
                                )}
                            </>
                        </div>
                    </section>

                    <div className="field__row-normal m-20">
                        <Checkbox className="mr-10" checked={props.isPublication} onChange={() => props.setPublication()} />
                        <p>Please Select if this is a News Publication (Eg. Wall Street Journal Facebook Page, Wall Street Journal Blog Etc).</p>
                    </div>

                    <div className={`field__row-normal m-20 ${props.igTokenList.length === 0 && "disablePlatform"}`}>
                        <button className="common__btn offset-hieight" onClick={() => props.verifyAccount()}>
                            <span> {props.verifyingAccount ? <Loader active size="small" /> : ""} Verify </span>
                        </button>
                        <p className="ml-1">*Validate to continue account Configuration</p>

                        <button className="common__btn ml-10 offset-hieight" disabled={!props.isAccountValid} onClick={() => props.onAddAccount()}>
                            <span> {props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                        </button>
                    </div>

                    <section className={`account__list-table ${props.igTokenList.length === 0 && "disablePlatform"}`}>
                        <AccountList
                            isAccountAdded={props.isAccountAdded}
                            accountListData={props.accountListData}
                            deleteAccount={props.deleteAccount}
                            allLocations={props.allLocations}
                        />
                    </section>
                </div>
                <div className="saveAndContinue">
                    <button className="common__btn" disabled={props.accountListData.length === 0} onClick={props.closeComponent}>
                        Save and continue
                    </button>
                </div>
            </section>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        igTokenList: state.tokensReducer.igTokenList,
        packageObj: state.globalReducer.packageObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchIgTokenList: () => dispatch(fetchIgTokenList()),
        storeIgSocialToken: (data) => dispatch(storeIgSocialToken(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDataInstagram);
